import React from 'react';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from 'modules/Notifications';

const NotificationsProvider = ({ children }) => (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    <SnackbarUtilsConfigurator />
    {children}
  </SnackbarProvider>
);

export default NotificationsProvider;
